import { render, staticRenderFns } from "./BasicPaginationNav.vue?vue&type=template&id=01e62a5c"
import script from "./BasicPaginationNav.vue?vue&type=script&lang=js"
export * from "./BasicPaginationNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports